import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import './conservazione.scss';
import {
  ConservazioneCaricaDocumentoStep1Module
} from './conservazione-carica-documento-step1/conservazione-carica-documento-step1.module';
import {
  ConservazioneCaricaDocumentoLibroContabileStep2Module
} from './conservazione-carica-documento-libro-contabile-step2/conservazione-carica-documento-libro-contabile-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroContabileStep2Module
} from './conservazione-carica-documento-registro-contabile-step2/conservazione-carica-documento-registro-contabile-step2.module';
import {
  ConservazioneCaricaDocumentoModelloDichiarativoStep2Module
} from './conservazione-carica-documento-modello-dichiarativo-step2/conservazione-carica-documento-modello-dichiarativo-step2.module';
import {
  ConservazioneCaricaDocumentoModelloVersamentoStep2Module
} from './conservazione-carica-documento-modello-versamento-step2/conservazione-carica-documento-modello-versamento-step2.module';
import {
  ConservazioneCaricaDocumentoBolletteStep2Module
} from './conservazione-carica-documento-bollette-step2/conservazione-carica-documento-bollette-step2.module';
import {
  ConservazioneCaricaDocumentoAltroDocumentoStep2Module
} from './conservazione-carica-documento-altro-documento-step2/conservazione-carica-documento-altro-documento-step2.module';
import {
  ConservazioneCaricaDocumentoFattureAttiveStep2Module
} from './conservazione-carica-documento-fatture-attive-step2/conservazione-carica-documento-fatture-attive-step2.module';
import {
  ConservazioneCaricaDocumentoFatturaPassivaStep2Module
} from './conservazione-carica-documento-fattura-passiva-step2/conservazione-carica-documento-fattura-passiva-step2.module';
import {
  ConservazioneCaricaDocumentoDDTAttivoStep2Module
} from './conservazione-carica-documento-ddt-attivo-step2/conservazione-carica-documento-ddt-attivo-step2.module';
import {
  ConservazioneCaricaDocumentoDDTPassivoStep2Module
} from './conservazione-carica-documento-ddt-passivo-step2/conservazione-carica-documento-ddt-passivo-step2.module';
import {
  ConservazioneCaricaDocumentoLulStep2Module
} from './conservazione-carica-documento-lul-step2/conservazione-carica-documento-lul-step2.module';
import {
  ConservazioneCaricaDocumentoStep3Module
} from './conservazione-carica-documento-step3/conservazione-carica-documento-step3.module';
import {
  ConservazioneCaricaMailPecSummaryModule
} from './conservazione-carica-mail-pec-summary/conservazione-carica-mail-pec-summary.module';
import {
  ConservazioneConsultaDocumentiModule
} from './conservazione-consulta-documenti/conservazione-consulta-documenti.module';
import {VerificaDocumentiCaricatiModule} from './verifica-documenti-caricati/verifica-documenti-caricati.module';
import {
  ConservazioneVersamentoResultModule
} from './conservazione-versamento-result/conservazione-versamento-result.module';
import {
  RequestInformationConservazioneModule
} from './request-information-conservazione/request-information-conservazione.module';
import {
  VerificaDocumentiCaricatiFilterModule
} from './component/verifica-documenti-caricati-filter/verifica-documenti-caricati-filter.module';
import {
  WorkerLibroContabileModalModule
} from './component/worker-libro-contabile-modal/worker-libro-contabile-modal.module';
import {
  WorkerRegistroContabileModalModule
} from './component/worker-registro-contabile-modal/worker-registro-contabile-modal.module';
import {
  WorkerModelliDichiarativiModalModule
} from './component/worker-modelli-dichiarativi-modal/worker-modelli-dichiarativi-modal.module';
import {
  WorkerModelliVersamentoModalModule
} from './component/worker-modelli-versamento-modal/worker-modelli-versamento-modal.module';
import {
  WorkerBolletteVersamentoModalModule
} from './component/worker-bollette-versamento-modal/worker-bollette-versamento-modal.module';
import {
  WorkerAltriDocumentiVersamentoModalModule
} from './component/worker-altri-documenti-versamento-modal/worker-altri-documenti-versamento-modal.module';
import {WorkerVersamentoModalModule} from './component/worker-versamento-modal/worker-versamento-modal.module';
import {
  WorkerFattureAttiveModalModule
} from './component/worker-fatture-attive-modal/worker-fatture-attive-modal.module';
import {
  WorkerFatturaElettronicaModalModule
} from './component/worker-fattura-elettronica-modal/worker-fattura-elettronica-modal.module';
import {WorkerMailPecModalModule} from './component/worker-mail-pec-modal/worker-mail-pec-modal.module';
import {
  WorkerConservazioneGeneratePackageModalModule
} from './component/worker-conservazione-generate-package-modal/worker-conservazione-generate-package-modal.module';
import {EditPecMetadataModalModule} from './component/edit-pec-metadata-modal/edit-pec-metadata-modal.module';
import {
  WorkerValidaFattureModalModule
} from './component/worker-valida-fatture-modal/worker-valida-fatture-modal.module';
import {WorkerValidaPecModalModule} from './component/worker-valida-pec-modal/worker-valida-pec-modal.module';
import {ConservazioneConfermaModule} from './component/conservazione-conferma/conservazione-conferma.module';
import {ConsultaDocumentiFilterModule} from './component/consulta-documenti-filter/consulta-documenti-filter.module';
import {ConservazioneComponent} from './conservazione';
import {
  ConservazioneCaricaDocumentoLibroGiornaleStep2Module
} from './conservazione-carica-documento-libro-giornale-step2/conservazione-carica-documento-libro-giornale-step2.module';
import {
  ConservazioneCaricaDocumentoPrimaNotaStep2Module
} from './conservazione-carica-documento-prima-nota-step2/conservazione-carica-documento-prima-nota-step2.module';
import {
  ConservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2Module
} from './conservazione-carica-documento-giornali-schede-magazzino-step2/conservazione-carica-documento-giornali-schede-magazzino-step2.module';
import {
  WorkerLibroGiornaleModalModule
} from './component/worker-libro-giornale-modal/worker-libro-giornale-modal.module';
import {WorkerPrimaNotaModalModule} from './component/worker-prima-nota-modal/worker-prima-nota-modal.module';
import {
  WorkerGiornaliSchedeMagazzinoModalModule
} from './component/worker-giornali-schede-magazzino-modal/worker-giornali-schede-magazzino-modal.module';
import {
  WorkerLibroInventariModalModule
} from './component/worker-libro-inventari-modal/worker-libro-inventari-modal.module';
import {
  WorkerRegistroOmaggiModalModule
} from './component/worker-registro-omaggi-modal/worker-registro-omaggi-modal.module';
import {WorkerLibroMastroModalModule} from './component/worker-libro-mastro-modal/worker-libro-mastro-modal.module';
import {WorkerLibroCespitiModalModule} from './component/worker-libro-cespiti-modal/worker-libro-cespiti-modal.module';
import {WorkerAltriLibriModalModule} from './component/worker-altri-libri-modal/worker-altri-libri-modal.module';
import {WorkerRegistroCorrispettiviIvaModalModule} from './component/worker-registro-corrispettivi-iva-modal/worker-registro-corrispettivi-iva-modal.module';
import {WorkerDichiarazioniFiscaliModalModule} from './component/worker-dichiarazioni-fiscali-modal/worker-dichiarazioni-fiscali-modal.module';
import {WorkerRicevuteFiscaliModalModule} from './component/worker-ricevute-fiscali-modal/worker-ricevute-fiscali-modal.module';
import {WorkerRegistroBeniDiTerziModalModule} from './component/worker-registro-beni-di-terzi-modal/worker-registro-beni-di-terzi-modal.module';
import {WorkerRegistroUnicoIvaModalModule} from './component/worker-registro-unico-iva-modal/worker-registro-unico-iva-modal.module';
import {
  WorkerLibroRegistriIvaModalModule
} from './component/worker-libro-registri-iva-modal/worker-libro-registri-iva-modal.module';
import {
  ConservazioneCaricaDocumentoLibroRegistriIvaStep2Module
} from './conservazione-carica-documento-libro-registri-iva-step2/conservazione-carica-documento-libro-registri-iva-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2Module
} from './conservazione-carica-documento-registro-riepilogativo-iva-step2/conservazione-carica-documento-registro-riepilogativo-iva-step2.module';
import {
  ConservazioneCaricaDocumentoAltriRegistriStep2Module
} from './conservazione-carica-documento-altri-registri-step2/conservazione-carica-documento-altri-registri-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroFattureAcquistoStep2Module
} from './conservazione-carica-documento-registro-fatture-acquisto-step2/conservazione-carica-documento-registro-fatture-acquisto-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroFattureVenditaStep2Module
} from './conservazione-carica-documento-registro-fatture-vendita-step2/conservazione-carica-documento-registro-fatture-vendita-step2.module';
import {
  ConservazioneCaricaDocumentoLibroInventariStep2Module
} from './conservazione-carica-documento-libro-inventari-step2/conservazione-carica-documento-libro-inventari-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroOmaggiStep2Module
} from './conservazione-carica-documento-registro-omaggi-step2/conservazione-carica-documento-registro-omaggi-step2.module';
import {
  ConservazioneCaricaDocumentoLibroMastroStep2Module
} from './conservazione-carica-documento-libro-mastro-step2/conservazione-carica-documento-libro-mastro-step2.module';
import {
  ConservazioneCaricaDocumentoLibroCespitiStep2Module
} from './conservazione-carica-documento-libro-cespiti-step2/conservazione-carica-documento-libro-cespiti-step2.module';
import {
  ConservazioneCaricaDocumentoAltriLibriStep2Module
} from './conservazione-carica-documento-altri-libri-step2/conservazione-carica-documento-altri-libri-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2Module
} from './conservazione-carica-documento-registro-corrispettivi-iva-step2/conservazione-carica-documento-registro-corrispettivi-iva-step2.module';
import {
  ConservazioneCaricaDocumentoDichiarazioniFiscaliStep2Module
} from './conservazione-carica-documento-dichiarazioni-fiscali-step2/conservazione-carica-documento-dichiarazioni-fiscali-step2.module';
import {
  ConservazioneCaricaDocumentoRicevuteFiscaliStep2Module
} from './conservazione-carica-documento-ricevute-fiscali-step2/conservazione-carica-documento-ricevute-fiscali-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroBeniDiTerziStep2Module
} from './conservazione-carica-documento-registro-beni-di-terzi-step2/conservazione-carica-documento-registro-beni-di-terzi-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Module
} from './conservazione-carica-documento-registro-unico-iva-step2/conservazione-carica-documento-registro-unico-iva-step2.module';
import {
  DigitalSignatureMissingModalModule
} from './conservazione-carica-documento-step1/digital-signature-missing-modal/digital-signature-missing-modal.module';
import {
  ConservazioneCaricaDocumentoNotificheSdiStep2Module
} from './conservazione-carica-documento-notifiche-sdi-step2/conservazione-carica-documento-notifiche-sdi-step2.module';
import {WorkerNotificheSdiModalModule} from './component/worker-notifiche-sdi-modal/worker-notifiche-sdi-modal.module';
import {
  WorkerCertificazioneUnicaModalModule
} from './component/worker-certificazione-unica-modal/worker-certificazione-unica-modal.module';
import {
  WorkerDocumentiBancariModalModule
} from './component/worker-documenti-bancari-modal/worker-documenti-bancari-modal.module';

import {WorkerManualiModalModule} from './component/worker-manuali-modal/worker-manuali-modal.module';
import {WorkerModelloIntrastatModalModule} from './component/worker-modello-intrastat-modal/worker-modello-intrastat-modal.module';
import {WorkerLibriSocialiModalModule} from './component/worker-libri-sociali-modal/worker-libri-sociali-modal.module';
import {WorkerRegistroLiquidazioniIvaModalModule} from './component/worker-registro-liquidazioni-iva-modal/worker-registro-liquidazioni-iva-modal.module';
import {
  ConservazioneCaricaDocumentoModelloF23F24Step2Module
} from './conservazione-carica-documento-modello-f23-f24-step2/conservazione-carica-documento-modello-f23-f24-step2.module';
import {
  ConservazioneCaricaDocumentoModello770Step2Module
} from './conservazione-carica-documento-modello-770-step2/conservazione-carica-documento-modello-770-step2.module';
import {
  ConservazioneCaricaDocumentoVerbaliVerificaScartoStep2Module
} from './conservazione-carica-documento-verbali-verifica-scarto-step2/conservazione-carica-documento-verbali-verifica-scarto-step2.module';
import {
  ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Module
} from './conservazione-carica-documento-nomine-deleghe-conservazione-step2/conservazione-carica-documento-nomine-deleghe-conservazione-step2.module';
import {
  ConservazioneCaricaDocumentoSchedeClinicheStep2Module
} from './conservazione-carica-documento-schede-cliniche-step2/conservazione-carica-documento-schede-cliniche-step2.module';
import {
  ConservazioneCaricaDocumentoContrattiDaFornitoreStep2Module
} from './conservazione-carica-documento-contratti-da-fornitore-step2/conservazione-carica-documento-contratti-da-fornitore-step2.module';
import {
  ConservazioneCaricaDocumentoContrattiAClienteStep2Module
} from './conservazione-carica-documento-contratti-a-cliente-step2/conservazione-carica-documento-contratti-a-cliente-step2.module';
import {
  ConservazioneCaricaDocumentoOrdiniDaClienteStep2Module
} from './conservazione-carica-documento-ordini-da-cliente-step2/conservazione-carica-documento-ordini-da-cliente-step2.module';
import {
  ConservazioneCaricaDocumentoOrdiniAFornitoreStep2Module
} from './conservazione-carica-documento-ordini-a-fornitore-step2/conservazione-carica-documento-ordini-a-fornitore-step2.module';
import {
  ConservazioneCaricaDocumentoModello730Step2Module
} from './conservazione-carica-documento-modello-730-step2/conservazione-carica-documento-modello-730-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroRifiutiStep2Module
} from './conservazione-carica-documento-registro-rifiuti-step2/conservazione-carica-documento-registro-rifiuti-step2.module';
import {
  ConservazioneCaricaDocumentoCmStep2Module
} from './conservazione-carica-documento-cm-step2/conservazione-carica-documento-cm-step2.module';
import {
  ConservazioneCaricaDocumentoCmrStep2Module
} from './conservazione-carica-documento-cmr-step2/conservazione-carica-documento-cmr-step2.module';
import {
  ConservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2Module
} from './conservazione-carica-documento-formulario-identificativo-rifiuti-step2/conservazione-carica-documento-formulario-identificativo-rifiuti-step2.module';
import {
  ConservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2Module
} from './conservazione-carica-documento-dichiarazioni-intento-attive-step2/conservazione-carica-documento-dichiarazioni-intento-attive-step2.module';
import {
  ConservazioneCaricaDocumentoDichiarazioniIntentoPassiveStep2Module
} from './conservazione-carica-documento-dichiarazioni-intento-passive-step2/conservazione-carica-documento-dichiarazioni-intento-passive-step2.module';
import {
  ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Module
} from './conservazione-carica-documento-documenti-doganali-emessi-step2/conservazione-carica-documento-documenti-doganali-emessi-step2.module';
import {
  ConservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2Module
} from './conservazione-carica-documento-documenti-doganali-ricevuti-step2/conservazione-carica-documento-documenti-doganali-ricevuti-step2.module';
import {
  ConservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2Module
} from './conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2/conservazione-carica-documento-modello-unico-dichiarazione-ambientale-step2.module';
import {
  ConservazioneCaricaDocumentoNoteSpeseETrasferteStep2Module
} from './conservazione-carica-documento-note-spese-e-trasferte-step2/conservazione-carica-documento-note-spese-e-trasferte-step2.module';
import {
  ConservazioneCaricaDocumentoPodStep2Module
} from './conservazione-carica-documento-pod-step2/conservazione-carica-documento-pod-step2.module';
import {WorkerBilanciModalModule} from './component/worker-bilanci-modal/worker-bilanci-modal.module';
import {
  ConservazioneCaricaDocumentoBilanciStep2Module
} from './conservazione-carica-documento-bilanci-step2/conservazione-carica-documento-bilanci-step2.module';
import {
  WorkerModelloF23F24ModalModule
} from './component/worker-modello-f23-f24-modal/worker-modello-f23-f24-modal.module';
import {WorkerModello770ModalModule} from './component/worker-modello-770-modal/worker-modello-770-modal.module';
import {WorkerVerbaliVerificaScartoModalModule} from './component/worker-verbali-verifica-scarto-modal/worker-verbali-verifica-scarto-modal.module';
import {WorkerNomineDelegheConservazioneModalModule} from './component/worker-nomine-deleghe-conservazione-modal/worker-nomine-deleghe-conservazione-modal.module';
import {
  WorkerRegistroRifiutiModalModule
} from './component/worker-registro-rifiuti-modal/worker-registro-rifiuti-modal.module';
import {
  WorkerSchedeClinicheModalModule
} from './component/worker-schede-cliniche-modal/worker-schede-cliniche-modal.module';
import {
  WorkerContrattiDaFornitoreModalModule
} from './component/worker-contratti-da-fornitore-modal/worker-contratti-da-fornitore-modal.module';
import {
  WorkerContrattiAClienteModalModule
} from './component/worker-contratti-a-cliente-modal/worker-contratti-a-cliente-modal.module';
import {
  WorkerOrdiniDaClienteModalModule
} from './component/worker-ordini-da-cliente-modal/worker-ordini-da-cliente-modal.module';
import {
  WorkerOrdiniAFornitoreModalModule
} from './component/worker-ordini-a-fornitore-modal/worker-ordini-a-fornitore-modal.module';

import {WorkerModello730ModalModule} from './component/worker-modello-730-modal/worker-modello-730-modal.module';
import {WorkerCmModalModule} from './component/worker-cm-modal/worker-cm-modal.module';
import {WorkerCmrModalModule} from './component/worker-cmr-modal/worker-cmr-modal.module';
import {
  WorkerFormularioIdentificativoRifiutiModalModule
} from './component/worker-formulario-identificativo-rifiuti-modal/worker-formulario-identificativo-rifiuti-modal.module';

import {WorkerDichiarazioniIntentoAttiveModalModule} from 
'./component/worker-dichiarazioni-intento-attive-modal/worker-dichiarazioni-intento-attive-modal.module';

import {WorkerDichiarazioniIntentoPassiveModalModule} from 
'./component/worker-dichiarazioni-intento-passive-modal/worker-dichiarazioni-intento-passive-modal.module';

import {WorkerDocumentiDoganaliEmessiModalModule} from 
'./component/worker-documenti-doganali-emessi-modal/worker-documenti-doganali-emessi-modal.module';

import {WorkerDocumentiDoganaliRicevutiModalModule} from 
'./component/worker-documenti-doganali-ricevuti-modal/worker-documenti-doganali-ricevuti-modal.module';

import {WorkerNoteSpeseETrasferteModalModule} from 
'./component/worker-note-spese-e-trasferte-modal/worker-note-spese-e-trasferte-modal.module';


import {WorkerModelloUnicoDichiarazioneAmbientaleModalModule} from 
'./component/worker-modello-unico-dichiarazione-ambientale-modal/worker-modello-unico-dichiarazione-ambientale-modal.module';

import {WorkerPodModalModule} from './component/worker-pod-modal/worker-pod-modal.module';

import {
  ConservazioneCaricaDocumentoCertificazioneUnicaStep2Module
} from './conservazione-carica-certificazione-unica-step2/conservazione-carica-documento-certificazione-unica-step2.module';
import {
  ConservazioneCaricaDocumentoDocumentiBancariStep2Module
} from './conservazione-carica-documenti-bancari-step2/conservazione-carica-documento-documenti-bancari-step2.module';
import {
  ConservazioneCaricaDocumentoManualiStep2Module
} from './conservazione-carica-documento-manuali-step2/conservazione-carica-documento-manuali-step2.module';
import {
  ConservazioneCaricaDocumentoModelloIntrastatStep2Module
} from './conservazione-carica-documento-modello-intrastat-step2/conservazione-carica-documento-modello-intrastat-step2.module';
import {
  ConservazioneCaricaDocumentoLibriSocialiStep2Module
} from './conservazione-carica-documento-libri-sociali-step2/conservazione-carica-documento-libri-sociali-step2.module';
import {
  ConservazioneCaricaDocumentoRegistroLiquidazioniIvaStep2Module
} from './conservazione-carica-documento-registro-liquidazioni-iva-step2/conservazione-carica-documento-registro-liquidazioni-iva-step2.module';
import {
  WorkerRegistroRiepilogativoIvaModalModule
} from './component/worker-registro-riepilogativo-iva-modal/worker-registro-riepilogativo-iva-modal.module';
import {
  WorkerAltriRegistriModalModule
} from './component/worker-altri-registri-modal/worker-altri-registri-modal.module';
import {
  WorkerRegistroFattureAcquistoModalModule
} from './component/worker-registro-fatture-acquisto-modal/worker-registro-fatture-acquisto-modal.module';
import {
  WorkerRegistroFattureVenditaModalModule
} from './component/worker-registro-fatture-vendita-modal/worker-registro-fatture-vendita-modal.module';
import {
  ConservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2Module
} from './conservazione-carica-documento-pec-posta-elettronica-certificata-step2/conservazione-carica-documento-pec-posta-elettronica-certificata-step2.module';
import {
  ConservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2Module
} from './conservazione-carica-documento-corrispondenza-ordinaria-step2/conservazione-carica-documento-corrispondenza-ordinaria-step2.module';
import {
  ConservazioneCaricaDocumentoPecNotifichePecStep2Module
} from './conservazione-carica-documento-pec-notifiche-pec-step2/conservazione-carica-documento-pec-notifiche-pec-step2.module';
import {
  WorkerPecPostaElettronicaCertificataModalModule
} from './component/worker-pec-posta-elettronica-certificata-modal/worker-pec-posta-elettronica-certificata-modal.module';
import {
  WorkerPecNotifichePecModalModule
} from './component/worker-pec-notifiche-pec-modal/worker-pec-notifiche-pec-modal.module';
import {
  VerificaStatoConservazioneModule
} from '../conservazione/verifica-stato-conservazione/verifica-stato-conservazione.module';
import { WorkerCorrispondenzaOrdinariaModalModule } from './component/worker-corrispondenza-ordinaria-modal/worker-corrispondenza-ordinaria-modal.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.conservazione', {
      url: '/conservazione',
      ncyBreadcrumb: {
        label: 'Conservazione',
        parent: 'home.home-index'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione'
      },
      views: {
        homeContent: {
          template: '<conservazione flex="100"></conservazione>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneModule: string = ng
  .module('conservazione', [
    'ui.bootstrap',
    uiRouter,
    ConservazioneCaricaDocumentoStep1Module,
    ConservazioneCaricaDocumentoLibroContabileStep2Module,
    ConservazioneCaricaDocumentoRegistroContabileStep2Module,
    ConservazioneCaricaDocumentoModelloDichiarativoStep2Module,
    ConservazioneCaricaDocumentoModelloVersamentoStep2Module,
    ConservazioneCaricaDocumentoBolletteStep2Module,
    ConservazioneCaricaDocumentoAltroDocumentoStep2Module,
    ConservazioneCaricaDocumentoFattureAttiveStep2Module,
    ConservazioneCaricaDocumentoNotificheSdiStep2Module,
    ConservazioneCaricaDocumentoCertificazioneUnicaStep2Module,
    ConservazioneCaricaDocumentoDocumentiBancariStep2Module,
    ConservazioneCaricaDocumentoManualiStep2Module,
    ConservazioneCaricaDocumentoModelloIntrastatStep2Module,
    ConservazioneCaricaDocumentoLibriSocialiStep2Module,
    ConservazioneCaricaDocumentoRegistroLiquidazioniIvaStep2Module,
    ConservazioneCaricaDocumentoFatturaPassivaStep2Module,
    ConservazioneCaricaDocumentoDDTAttivoStep2Module,
    ConservazioneCaricaDocumentoDDTPassivoStep2Module,
    ConservazioneCaricaDocumentoLulStep2Module,
    ConservazioneCaricaDocumentoLibroGiornaleStep2Module,
    ConservazioneCaricaDocumentoPrimaNotaStep2Module,
    ConservazioneCaricaDocumentoGiornaliSchedeMagazzinoStep2Module,
    ConservazioneCaricaDocumentoLibroInventariStep2Module,
    ConservazioneCaricaDocumentoRegistroOmaggiStep2Module,
    ConservazioneCaricaDocumentoLibroMastroStep2Module,
    ConservazioneCaricaDocumentoLibroCespitiStep2Module,
    ConservazioneCaricaDocumentoAltriLibriStep2Module,
    ConservazioneCaricaDocumentoLibroRegistriIvaStep2Module,
    ConservazioneCaricaDocumentoStep3Module,
    ConservazioneCaricaMailPecSummaryModule,
    ConservazioneConsultaDocumentiModule,
    VerificaDocumentiCaricatiModule,
    ConservazioneVersamentoResultModule,
    RequestInformationConservazioneModule,
    VerificaDocumentiCaricatiFilterModule,
    WorkerLibroContabileModalModule,
    WorkerRegistroContabileModalModule,
    WorkerModelliDichiarativiModalModule,
    WorkerModelliVersamentoModalModule,
    WorkerBolletteVersamentoModalModule,
    WorkerAltriDocumentiVersamentoModalModule,
    WorkerVersamentoModalModule,
    WorkerFattureAttiveModalModule,
    WorkerNotificheSdiModalModule,
    WorkerCertificazioneUnicaModalModule,
    WorkerDocumentiBancariModalModule,
    WorkerManualiModalModule,
    WorkerModelloIntrastatModalModule,
    WorkerLibriSocialiModalModule,
    WorkerRegistroLiquidazioniIvaModalModule,
    WorkerFatturaElettronicaModalModule,
    WorkerMailPecModalModule,
    WorkerConservazioneGeneratePackageModalModule,
    EditPecMetadataModalModule,
    WorkerValidaFattureModalModule,
    WorkerValidaPecModalModule,
    WorkerLibroGiornaleModalModule,
    WorkerPrimaNotaModalModule,
    WorkerGiornaliSchedeMagazzinoModalModule,
    WorkerLibroInventariModalModule,
    WorkerRegistroOmaggiModalModule,
    WorkerLibroMastroModalModule,
    WorkerLibroCespitiModalModule,
    WorkerAltriLibriModalModule,
    WorkerLibroRegistriIvaModalModule,
    ConservazioneConfermaModule,
    ConsultaDocumentiFilterModule,
    DigitalSignatureMissingModalModule,
    ConservazioneCaricaDocumentoModelloF23F24Step2Module,
    WorkerModelloF23F24ModalModule,
    ConservazioneCaricaDocumentoModello770Step2Module,
    WorkerModello770ModalModule,
    ConservazioneCaricaDocumentoVerbaliVerificaScartoStep2Module,
    WorkerVerbaliVerificaScartoModalModule,
    ConservazioneCaricaDocumentoNomineDelegheConservazioneStep2Module,
    WorkerNomineDelegheConservazioneModalModule,
    ConservazioneCaricaDocumentoModello730Step2Module,
    WorkerModello730ModalModule,
    ConservazioneCaricaDocumentoSchedeClinicheStep2Module,
    WorkerSchedeClinicheModalModule,
    ConservazioneCaricaDocumentoOrdiniAFornitoreStep2Module,
    WorkerOrdiniAFornitoreModalModule,
    ConservazioneCaricaDocumentoOrdiniDaClienteStep2Module,
    WorkerOrdiniDaClienteModalModule,
    ConservazioneCaricaDocumentoContrattiAClienteStep2Module,
    WorkerContrattiAClienteModalModule,
    ConservazioneCaricaDocumentoRegistroRifiutiStep2Module,
    WorkerRegistroRifiutiModalModule,
    ConservazioneCaricaDocumentoContrattiDaFornitoreStep2Module,
    WorkerContrattiDaFornitoreModalModule,
    ConservazioneCaricaDocumentoCmStep2Module,
    WorkerCmModalModule,
    ConservazioneCaricaDocumentoCmrStep2Module,
    WorkerCmrModalModule,
    ConservazioneCaricaDocumentoFormularioIdentificativoRifiutiStep2Module,
    WorkerFormularioIdentificativoRifiutiModalModule,
    ConservazioneCaricaDocumentoDichiarazioniIntentoAttiveStep2Module,
    WorkerDichiarazioniIntentoAttiveModalModule,
    ConservazioneCaricaDocumentoDichiarazioniIntentoPassiveStep2Module,
    WorkerDichiarazioniIntentoPassiveModalModule,
    ConservazioneCaricaDocumentoDocumentiDoganaliEmessiStep2Module,
    WorkerDocumentiDoganaliEmessiModalModule,
    ConservazioneCaricaDocumentoDocumentiDoganaliRicevutiStep2Module,
    WorkerDocumentiDoganaliRicevutiModalModule,
    ConservazioneCaricaDocumentoModelloUnicoDichiarazioneAmbientaleStep2Module,
    WorkerModelloUnicoDichiarazioneAmbientaleModalModule,
    ConservazioneCaricaDocumentoNoteSpeseETrasferteStep2Module,
    WorkerNoteSpeseETrasferteModalModule,
    ConservazioneCaricaDocumentoRegistroCorrispettiviIvaStep2Module,
    WorkerRegistroCorrispettiviIvaModalModule,
    ConservazioneCaricaDocumentoDichiarazioniFiscaliStep2Module,
    WorkerDichiarazioniFiscaliModalModule,
    ConservazioneCaricaDocumentoRicevuteFiscaliStep2Module,
    WorkerRicevuteFiscaliModalModule,
    ConservazioneCaricaDocumentoRegistroBeniDiTerziStep2Module,
    WorkerRegistroBeniDiTerziModalModule,
    ConservazioneCaricaDocumentoRegistroUnicoIvaStep2Module,
    WorkerRegistroUnicoIvaModalModule,
    ConservazioneCaricaDocumentoPodStep2Module,
    WorkerPodModalModule,
    ConservazioneCaricaDocumentoBilanciStep2Module,
    WorkerBilanciModalModule,
    ConservazioneCaricaDocumentoRegistroRiepilogativoIvaStep2Module,
    WorkerRegistroRiepilogativoIvaModalModule,
    ConservazioneCaricaDocumentoRegistroFattureAcquistoStep2Module,
    WorkerRegistroFattureAcquistoModalModule,
    ConservazioneCaricaDocumentoRegistroFattureVenditaStep2Module,
    WorkerRegistroFattureVenditaModalModule,
    ConservazioneCaricaDocumentoAltriRegistriStep2Module,
    WorkerAltriRegistriModalModule,
    ConservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2Module,
    WorkerPecPostaElettronicaCertificataModalModule,
    ConservazioneCaricaDocumentoCorrispondenzaOrdinariaStep2Module,
    WorkerCorrispondenzaOrdinariaModalModule,
    ConservazioneCaricaDocumentoPecNotifichePecStep2Module,
    WorkerPecNotifichePecModalModule,
    VerificaStatoConservazioneModule,
  ])
  .component('conservazione', ConservazioneComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione.module.ts